// extracted by mini-css-extract-plugin
export var dropdownButton = "_3g-0";
export var fullWidthDropdownButton = "_3g-1";
export var icon = "_3g-3";
export var iconPlaceholder = "_3g-2";
export var menuItemRow = "_3g-8";
export var separator = "_3g-c";
export var shortcutContainer = "_3g-7";
export var shortcutIconLg = "_3g-6";
export var shortcutIconMd = "_3g-5";
export var shortcutIconSm = "_3g-4";
export var submenuChevron = "_3g-b";
export var submenuDropdown = "_3g-9";
export var submenuTriggerRow = "_3g-a";